import Vue from 'vue'

const state = {
  lista: [],
  perfil: [],
  permissoesPorPerfil: []
}

const mutations = {
  setTipoUsuarios (state, data) {
    state.lista = data
  },
  setPerfil (state, data) {
    state.perfil = data

    let permissoes = []
    for (let i in state.perfil.recursos) {
      permissoes.push(state.perfil.recursos[i].id)
    }
    state.permissoesPorPerfil = permissoes
  },
  atualizaPermissoesPorPerfil (state, permissoes) {
    state.permissoesPorPerfil = permissoes
  }
}

const getters = {
  getNomePerfil: (state) => (id) => {
    let result = state.lista.find(item => item.id === id)
    return result.nome
  },
  getListaCombo: state => {
    return state.lista
  }
}

const actions = {
  buscarTipoUsuarios (context) {
    Vue.http.get('api/perfil/buscarPerfis').then(response => {
      context.commit('setTipoUsuarios', response.body.data.perfis)
    })
  },
  getPerfil (context, id) {
    Vue.http.get('api/perfil/' + id).then(response => {
      context.commit('setPerfil', response.body.data)
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/tipoUsuario.js